import ClientPassengerSSRInterface from '../../interfaces/client/PassengerSSR'

export default (passengerSSR: ClientPassengerSSRInterface) =>
  !passengerSSR.isConfirmed
